import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { useGetAccountsSharingMultiAccountsReportsWithQuery } from 'reporting-snowflake/__generated__/chirp/com/hubspot/multi/account/configuration/manager/rpc/MultiAccountReportingConfigurationChirpService.hooks';
import I18n from 'I18n';
export const useMultiAccountOptions = ({
  selectedAccountIds
}) => {
  const currentPortalId = PortalIdParser.get();
  const {
    data: accountsData,
    loading,
    error
  } = useGetAccountsSharingMultiAccountsReportsWithQuery();
  const accountOptions = useMemo(() => {
    if (!(accountsData !== null && accountsData !== void 0 && accountsData.accounts)) return [];
    return Object.entries(accountsData.accounts).map(([portalId, accountName]) => {
      const isCurrentAccount = currentPortalId && portalId === String(currentPortalId);
      return {
        text: isCurrentAccount ? I18n.text('reporting-snowflake.multi-account-selector.logged-in-account', {
          accountName: I18n.SafeString(accountName)
        }) : accountName,
        value: portalId
      };
    });
  }, [accountsData, currentPortalId]);
  const selectedAccountIdsWithDefaults = useMemo(() => {
    if (currentPortalId && selectedAccountIds.length === 0 && accountsData !== null && accountsData !== void 0 && accountsData.accounts && String(currentPortalId) in accountsData.accounts) {
      return [String(currentPortalId)];
    }
    return selectedAccountIds;
  }, [currentPortalId, selectedAccountIds, accountsData]);
  return {
    accountOptions,
    accountsData,
    selectedAccountIdsWithDefaults,
    loading,
    error
  };
};